import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil, debounceTime, distinctUntilChanged } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "fury-charge-manually-modal",
  templateUrl: "./charge-manually-modal.component.html",
  styleUrls: ["./charge-manually-modal.component.scss"],
})
export class ChargeManuallyModalComponent implements OnInit, OnDestroy {
  ngUnSubscribe = new Subject<void>();
  chargemanuallyForm = new FormGroup({
    orderId: new FormControl(null),
    claimId: new FormControl(null),
    category: new FormControl(null, [Validators.required]),
    amount: new FormControl(null, [Validators.required]),
  });
  pastDueForm = new FormGroup({
    agreementNumber: new FormControl(""),
  });
  agreements!: any;
  claims!: any;
  pastDues = [];
  orderUpcomingPaymentId = "";
  paymentTypeEnum = {
    0: "default-payment",
    1: "credit-debit-card",
    2: "bank-payment",
    3: "check-payment",
  };
  paymentType = this.paymentTypeEnum[0];
  cardType = "";
  month = Number(new Date().getMonth() + 1);
  expiryYear: number = Number(new Date().getFullYear().toString().slice(2, 4));
  cardDetailsForm = new FormGroup({
    cardHoldarName: new FormControl("", [Validators.required]),
    cardNumber: new FormControl("", [Validators.required]),
    expiryMonth: new FormControl("", [
      Validators.required,
      Validators.max(12),
      Validators.min(1),
    ]),
    expiryYear: new FormControl("", [
      Validators.required,
      Validators.min(this.expiryYear),
    ]),
    cvv: new FormControl("", [Validators.required]),
    monthYear: new FormControl("", [Validators.required]),
  });
  bankDetailsForm = new FormGroup({
    routingNumber: new FormControl("", [
      Validators.required,
      Validators.minLength(9),
      Validators.maxLength(9),
    ]),
    accountNumber: new FormControl("", [
      Validators.required,
      Validators.minLength(4),
    ]),
    nameOnAccount: new FormControl("", [
      Validators.minLength(2),
      Validators.required,
    ]),
    bankName: new FormControl("", [Validators.required]),
    transactionNumber: new FormControl("", [Validators.required]),
  });
  chequeDetailForm = new FormGroup({
    checkNumber: new FormControl("", [
      Validators.required,
      Validators.minLength(4),
    ]),
  });
  defaultCardForm = new FormGroup({
    cardHoldarName: new FormControl("", [Validators.required]),
    cardNumber: new FormControl("", [Validators.required]),
    expiryMonth: new FormControl("", [
      Validators.required,
      Validators.max(12),
      Validators.min(1),
    ]),
    expiryYear: new FormControl("", [
      Validators.required,
      Validators.min(this.expiryYear),
    ]),
    cvv: new FormControl("", [Validators.required]),
    monthYear: new FormControl("", [Validators.required]),
  });
  defaultCard: any;
  constructor(
    public dialogRef: MatDialogRef<ChargeManuallyModalComponent>,
    private apiService: ApiService,
    private activateRoute: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public userId: string,
    public commonService: CommonService,
  ) {}

  ngOnInit() {
    this.cardDetailsForm
    .get("monthYear")
    ?.valueChanges.pipe(takeUntil(this.ngUnSubscribe))
    .subscribe((res: string) => {
      if (res) {
        if (res.length === 4) {
          this.cardDetailsForm.patchValue({
            expiryMonth: res.substring(0, 2),
            expiryYear: res.substring(2, 4),
          });
          if (
            this.cardDetailsForm.get("expiryYear").value ===
              this.expiryYear.toString() &&
            Number(this.cardDetailsForm.get("expiryMonth").value) < this.month
          ) {
            this.cardDetailsForm
              .get("expiryMonth")
              .setErrors({ notValid: true });
          }
        }
      }
    });
    if (this.userId) {
      this.getPastDue();
      this.getAllAgreement();
      this.getAllClaims();
      this.getuserDefaultPaymentDetails();
    }
  }

  close() {
    this.dialogRef.close();
  }
  getAllAgreement() {
    this.apiService
      .get(
        `${endpoints.customerDashboard.getCustomerAgreements(
          this.userId
        )}?page=1&size=100`
      )
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          this.agreements = res.body?.agreements?.data;
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  getAllClaims() {
    this.apiService
      .get(
        `${endpoints.customerDashboard.getClaims(this.userId)}?page=1&size=100`
      )
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          this.claims = res.body?.claims?.data;
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  handleChangeCategory(event: MatSelectChange) {
    this.chargemanuallyForm.get("orderId").setValue(null);
    this.chargemanuallyForm.get("claimId").setValue(null);
    const claimIdControll = this.chargemanuallyForm.get("claimId");
    const orderIdControll = this.chargemanuallyForm.get("orderId");
    if (event.value === "Premium") {
      orderIdControll.setValidators(Validators.required);
      claimIdControll.clearValidators();
    } else {
      claimIdControll.setValidators(Validators.required);
      orderIdControll.clearValidators();
    }
    claimIdControll.updateValueAndValidity();
    orderIdControll.updateValueAndValidity();
  }

  get showPaymentField() {
    if (
      this.chargemanuallyForm.get("category").value &&
      this.chargemanuallyForm.get("category").value === "Premium" &&
      this.agreements?.length
    ) {
      return true;
    }
    if (
      this.chargemanuallyForm.get("category").value &&
      this.chargemanuallyForm.get("category").value !== "Premium" &&
      this.claims?.length
    ) {
      return true;
    }
    return false;
  }
  getPastDue() {
    this.apiService
      .get(
        `${endpoints.customerDashboard.payment.upcomingPayment(
          this.userId
        )}?page=1&size=9999&isDue=1`
      )
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.pastDues = res.body?.OrderUpcomingPayment?.data;
            if (this.pastDues.length > 0) this.chargemanuallyForm.disable();
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  checkPastDueAndProceed(e: any) {
    const pastDueData = this.pastDues.find(
      (item: any) =>
        item?.agreementNumber === this.pastDueForm.value.agreementNumber
    );
    this.orderUpcomingPaymentId = pastDueData?.orderUpcomingPaymentId;
    this.chargemanuallyForm.patchValue({
      category: "Premium",
      orderId: pastDueData?.ordertId,
      amount: pastDueData?.amountPaid,
    });
  }
  getuserDefaultPaymentDetails(){
    this.apiService.get(endpoints.customerDashboard.getUserDefaultPayment(this.userId)).pipe(takeUntil(this.ngUnSubscribe)).subscribe({
      next: (res: HttpResponse<any>)=>{
        if(res.body){
          this.defaultCard = res.body?.defaultPaymentDetail;
          this.defaultCardForm.patchValue({
            cardHoldarName: this.defaultCard?.cardHolderName,
            cardNumber: this.defaultCard?.cardNumber,
            cvv: this.defaultCard?.cvv,
            expiryMonth: this.defaultCard?.expiryMonth,
            expiryYear: this.defaultCard?.expiryYear,
            monthYear: `${this.defaultCard?.expiryMonth}${this.defaultCard?.expiryYear.substring(2, 4)}`
          })
        }
      },
      error: (error: HttpErrorResponse)=>{
        this.apiService.alert(error.message, ErrorType.Error);
      }
    })
  }
  onTabChange(event: MatTabChangeEvent) {
    this.paymentType = this.paymentTypeEnum[event.index];
  }
  detectCardType(cardNumber: string) {
    this.cardType = this.commonService.getCardType(cardNumber);
  }
  checkPaymentAndSubmit() {
    let payload: any;
    if(this.paymentType === this.paymentTypeEnum[0]){
      if(this.defaultCardForm.invalid || this.chargemanuallyForm.status === "INVALID"){
        this.defaultCardForm.markAllAsTouched();
        this.chargemanuallyForm.markAllAsTouched();
        return;
      }
      payload = {
        paymentDetail: {
        cardNumber: this.defaultCardForm.value.cardNumber,
        cardHoldarName: this.defaultCardForm.value.cardHoldarName,
        cvv: this.defaultCardForm.value.cvv,
        expiryMonth: this.defaultCardForm.value.expiryMonth,
        expiryYear: this.defaultCardForm.value.expiryYear
       },
       paymentMethod: 'credit-debit-card'
      }
    }
    if(this.paymentType === this.paymentTypeEnum[1]){
      if(this.cardDetailsForm.invalid || this.chargemanuallyForm.status === "INVALID"){
        this.cardDetailsForm.markAllAsTouched();
        this.chargemanuallyForm.markAllAsTouched();
        return;
      }
      payload = {
        paymentDetail: {
        cardNumber: this.cardDetailsForm.value.cardNumber,
        cardHoldarName: this.cardDetailsForm.value.cardHoldarName,
        cvv: this.cardDetailsForm.value.cvv,
        expiryMonth: this.cardDetailsForm.value.expiryMonth,
        expiryYear: `20${this.cardDetailsForm.value.expiryYear}`
       },
       paymentMethod: 'credit-debit-card'
      }
    }
    if(this.paymentType === this.paymentTypeEnum[2]){
      if(this.bankDetailsForm.invalid || this.chargemanuallyForm.status === "INVALID"){
        this.bankDetailsForm.markAllAsTouched();
        this.chargemanuallyForm.markAllAsTouched();
        return;
      }
      payload = {
        bankDetail: {
          bankName: this.bankDetailsForm.value.bankName,
          routingNumber: this.bankDetailsForm.value.routingNumber,
          accountNumber: this.bankDetailsForm.value.accountNumber,
          nameOnAccount: this.bankDetailsForm.value.nameOnAccount,
          transactionNumber: this.bankDetailsForm.value.transactionNumber
       },
        paymentMethod: 'bank-payment'
      }
    }
    if(this.paymentType === this.paymentTypeEnum[3]){
      if(this.chequeDetailForm.invalid || this.chargemanuallyForm.status === "INVALID"){
        this.chequeDetailForm.markAllAsTouched();
        this.chargemanuallyForm.markAllAsTouched();
        return;
      }
      payload = {
        checkNumber: this.chequeDetailForm.value.checkNumber,
         paymentMethod: 'check-payment'
      }
    }
    this.submit(payload);
   
  }
  submit(paymentPayload: any) {
    let payload: any = Object.assign(this.chargemanuallyForm.value, paymentPayload);
    payload.userId = this.userId;
    if (this.pastDues.length)
      payload.orderUpcomingPaymentId = this.orderUpcomingPaymentId;
    this.apiService
      .post(endpoints.customerDashboard.createChargeManually, payload)
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.apiService.alert(res.body.message, ErrorType.Success);
            this.dialogRef.close(res.body);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  getBankDetail() {
    if(this.bankDetailsForm.value.routingNumber.length !==9 ) {
     this.bankDetailsForm.get('bankName').setValue('');
     return;
    }
    
       this.apiService
         .get(endpoints.customerDashboard.checkout.getBankDetail(this.bankDetailsForm.value.routingNumber))
         .pipe(debounceTime(1000))
         .pipe(distinctUntilChanged())
         .subscribe(
           (res: any) => {
             if(res?.body?.bankName){
               this.bankDetailsForm.get('bankName').setValue(res?.body?.bankName);
               return;
             }
             this.bankDetailsForm.get('bankName').setValue('');
           },
           (err) => {
             this.bankDetailsForm.get('bankName').setValue('');
             this.apiService.alert(err.error.message, ErrorType.Error)
           }
         );
  }

  ngOnDestroy() {
    this.ngUnSubscribe.next();
    this.ngUnSubscribe.complete();
  }
}
